import React from 'react'
export default function RefreshIcon() {
    return (
        <svg className='svg--stroke' viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9039 12.0506C20.5773 15.1205 18.8389 17.9973 15.9624 19.659C11.1832 22.4199 5.07208 20.7815 2.31282 15.9995L2.01893 15.4901M1.02906 9.94977C1.35563 6.87989 3.09402 4.00311 5.97057 2.34134C10.7498 -0.419555 16.8609 1.21888 19.6201 6.0009L19.914 6.51023M0.966797 18.1353L1.82736 14.9218L5.03902 15.7828M16.8946 6.21754L20.1062 7.07861L20.9668 3.86505" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        </svg>
    )
}